import { Identificador } from './../../models/identificador.model';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IdentificadorService {
  baseUrlAdmin = environment.baseUrlAdmin;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  public create(identificador: any): Observable<Identificador> {
    const service = 'identificadores';
    return this.http.post<Identificador>(this.baseUrlAdmin + service, identificador);
  }

  public read(): Observable<Identificador[]> {
    const service = 'identificadores';
    return this.http.get<Identificador[]>(this.baseUrlAdmin + service);
  }

  public readByIdentificador(identificador: string): Observable<any> {
    const service = `${'identificadores'}/${identificador}`;
    return this.http.get<any>(this.baseUrlAdmin + service);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
